import { createSelector } from 'reselect';

const notificationsSelector = ({ notifications }) => notifications;

export const selectNotifications = createSelector(notificationsSelector, (notifications) =>
  notifications.getIn(['notifications', 'data']),
);

export const selectNotificationsLoading = createSelector(notificationsSelector, (notifications) =>
  notifications.getIn(['notifications', 'loading']),
);

export const selectNotificationsLoadingMore = createSelector(
  notificationsSelector,
  (notifications) => notifications.getIn(['notifications', 'loadingMore']),
);

export const selectNotificationsError = createSelector(notificationsSelector, (notifications) =>
  notifications.getIn(['notifications', 'error']),
);

export const selectSidebarIsVisible = createSelector(notificationsSelector, (notifications) =>
  notifications.get('sidebarIsVisible'),
);

export const selectNewNotifications = createSelector(notificationsSelector, (notifications) =>
  notifications.getIn(['notifications', 'unreadCount']),
);

export const selectHasNewNotifications = createSelector(
  selectNewNotifications,
  (notifications) => !!notifications,
);

export const selectNotificationsQueue = createSelector(notificationsSelector, (notifications) =>
  notifications.get('queue'),
);

export const selectNotificationsHasNextPage = createSelector(
  notificationsSelector,
  (notifications) => notifications.getIn(['notifications', 'hasNextPage']),
);

export const selectNotificationModalVisible = createSelector(
  notificationsSelector,
  (notifications) => notifications.get('modalIsVisible'),
);

export const selectNotificationModalData = createSelector(notificationsSelector, (notifications) =>
  notifications.get('modal'),
);
